package locales.cldr.data

// Auto-generated code from CLDR definitions, don't edit
import locales.cldr._

object currencydata {
  val currencyTypes: List[CurrencyType] = List()
  val fractions: List[CurrencyDataFractionsInfo] = List(CurrencyDataFractionsInfo("DEFAULT", 2, 0, None, None))
  val regions: List[CurrencyDataRegion] = List()
  val numericCodes: List[CurrencyNumericCode] = List()
}